import * as React from 'react';

import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers/index';

import './Menu.scss';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

export const MenuFooter = ({ hasFooter, pages, currentPage, changePageSize }: any) => (
  <div className="menu-bottom">
    {hasFooter && currentPage && pages && !isNaN(pages) && (
      <div className="menu-bottom__submenu-bottom">
        <div className="menu-bottom__show">
          <FormattedMessageHelper tagName="span" id="menuFooter.show" defaultMessage={localeData.en['menuFooter.show']} />
          <input type="number" className="menu-bottom__show-num" onChange={changePageSize} placeholder={currentPage.toString()} />
          <FormattedMessageHelper tagName="span" id="menuFooter.outOf" defaultMessage={localeData.en['menuFooter.outOf']} />{' '}
          {Math.round(currentPage * pages)}
        </div>
        <div className={addModifiers('menu-bottom__filter-button', ['active'])}>
          <FormattedMessageHelper tagName="span" id="menuFooter.filter" defaultMessage={localeData.en['menuFooter.filter']} />
        </div>
      </div>
    )}
  </div>
);
